/**
 * @description Hook utilizado para manipular os órgãos
 * @author Diego Sabino Amorim de Araújo
 * @file useOrgaoService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useDispatch } from 'react-redux'
import actionTypes from 'utils/actionTypes'
import { useFetch } from './useFetch'

export const useOrgaoService = () => {
  const fetch = useFetch()
  const dispatch = useDispatch()

  const listarOrgaosAsync = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`orgaos`)
      return response.data.orgaos
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarOrgaosAsyncRequisicoes = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`orgaos/requisicoes/todos`)
      return response.data.orgaos
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarOrgaosGlobal = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`orgaos`)
      dispatch({
        type: actionTypes.FETCH_ORGAOS,
        orgaos: response.data.orgaos,
      })
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarOrgao = async (id, setOrgao, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`orgaos/${id}`)
      setOrgao(response.data.orgao)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarOrgaoAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`orgaos/${id}`)
      return response.data.orgao
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarOrgao = async (dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const novoOrgao = {
        nome: dados.nome,
        sigla: dados.sigla,
        descricao: dados.descricao,
      }
      await fetch.postOpen('/orgaos/', novoOrgao)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(true)
    }
  }

  const editarOrgao = async (id, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const orgao = {
        id: dados.id,
        nome: dados.nome,
        sigla: dados.sigla,
        descricao: dados.descricao,
      }
      await fetch.putOpen(`/orgaos/${id}`, orgao)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(true)
    }
  }

  const deletarOrgao = async (id, setProcessando) => {
    if (setProcessando) setProcessando(true)
    await fetch.del(`orgaos/${id}`)
    if (setProcessando) setProcessando(false)
  }

  return {
    listarOrgaosAsync,
    listarOrgaosGlobal,
    listarOrgao,
    listarOrgaoAsync,
    deletarOrgao,
    cadastrarOrgao,
    editarOrgao,
    listarOrgaosAsyncRequisicoes,
  }
}
